import { Modal, Button, Input, Select, Popconfirm, message, InputNumber } from 'antd';
import React, { Component } from 'react'
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
const Option = Select.Option;


export default class ConactInformation extends Component {
    state = { 
        visible: false,
        record: {}, 
        data: [],
        pagination: {
            pageSize: 10,
            current: 1,
        },
        canAdd: false,
        searchParams: {},
        isEdit: false,
        provinceList:[],
        cityList:[],
    }

    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const options = {
            method: 'POST',
            url:API_URL.contract.queryList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { data, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    data: data,
                    pagination,
                });
            },
        };
        $.sendRequest(options);
    }

    getRegionTree = () => {
        const { isEdit } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.common.getRegionTree,
            data: {},
            dataType: 'json',
            doneResult: res => {
                let { provinceList } = this.state;
                const { datas = [] } = res;
                provinceList = datas.map(
                    i => ({
                        label: i.regionName,
                        children: i.children.map(j => ({
                            label: j.regionName,
                    })),
                    })
                );
                this.setState({provinceList})
            },
        };
        $.sendRequest(options);
    }

    queryCityList = (value) => {
        let { provinceList, cityList } = this.state;
        cityList = [];
        provinceList.map(i=>{
            if(i.label == value){
                cityList.push(...i.children)
            }
        });
        this.setState({cityList})
    }

    show = (record) => {
        const { searchParams } = this.state;
        searchParams.customerCompanyId = record.customerCompanyId;
        this.setState({
            record,
            visible: true,
            searchParams,
        },() => {
            this.loadData();
            this.getRegionTree();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            record: {}, 
            data: [],
            pagination: {
                pageSize: 10,
                current: 1,
            },
            canAdd: false,
            searchParams: {},
            isEdit: false,
            });
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination: pagination.pagination,
        }, () => {
            this.loadData();
        });
    }

    addPerson = () => {
        let { data, canAdd } = this.state;
        canAdd = true;
        data.unshift({edit: true});
        this.setState({
            canAdd,
            data,
        })
    }

    edit = (value, index) => {
        const { data } = this.state;
        data[index].edit = value;
        this.setState({
            data,
            isEdit: true,
        });
    }

    save = (record,tableindex) => {
        let { canAdd, data, isEdit } = this.state;
        const { 
            userName,
            positionName,
            userMobile,
            userMail,
            provinceName,
            cityName,
            countyName,
            address,
            status,
            comment,
            customerCompanyUserId,
        } = record;
        let url;
        const { customerCompanyId } = this.state.record;
        if (userMobile) {
            const canuserMobile = data.some((i, index) => tableindex !== index && i.userMobile === userMobile);
            if (canuserMobile) {
                return message.warning('请勿添加相同的电话号码')
            }
        }
        if( !userName && !positionName && !userMobile && !userMail && !provinceName && !cityName && !countyName && !address && !status && !comment){
            return message.warning('请至少输入一项')
        }
        data.map(i => {
            i.edit = false;
        })
        canAdd = false;
        this.setState({
            canAdd,
            data,
        })
        if (isEdit && customerCompanyUserId) {
            url = API_URL.contract.updateCustomerCompanyUser
        }else{
            url = API_URL.contract.addCustomerCompanyUser
        }
        const options = {
            method: 'POST',
            url,
            data: { 
                userName,
                positionName,
                userMobile,
                userMail,
                provinceName,
                cityName,
                countyName,
                address,
                status,
                comment,
                customerCompanyId,
                customerCompanyUserId, 
            },
            dataType: 'json',
            doneResult: () => {
                this.loadData();
                this.setState({
                    isEdit: false,
                    provinceList:[],
                    cityList:[],
                })
            },
        };
        $.sendRequest(options);
    }

    handleChange = (value,index,key) => {
        const { data } = this.state;
        if(key == 'provinceName'){
            let { provinceList, cityList } = this.state;
            data[index][key] = value;
            data[index].cityName = undefined;
            cityList = [];
            provinceList.map(i=>{
                if(i.label == value){
                    cityList.push(i.children[0])
                }
            });
            this.setState({provinceList, cityList});
        }else{
            data[index][key] = value;
        }
        this.setState({
            data,
        })
    }

    onDelete = (record,index) => {
        const { data } = this.state;
        const { customerCompanyUserId } = record;
        if(customerCompanyUserId){
            const options = {
                method: 'POST',
                url: API_URL.contract.deleteCustomerCompanyUser,
                data: { customerCompanyUserId },
                dataType: 'json',
                doneResult: () => {
                    this.loadData();
                },
            };
            $.sendRequest(options);
        }else{
            data.splice(index,1)
        }
        this.setState({
            data,
            canAdd: false,
        })
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    handleSearchChange = (value, key) => {
        const {searchParams} = this.state;
        searchParams[key] = value;
        this.setState({searchParams})
    }

    getColumns = () => {
        const columns = [{
            title: '联系人姓名',
            dataIndex: 'userName',
            key: 'userName',
            width: 80,
            render: (text,record,index) => {
                const {edit} = record                 
                return edit?<Input style={{width:'100%'}} placeholder="请输入" value={text} onChange={e => this.handleChange(e.target.value,index,'userName')}/>:text
            }
        }, {
            title: '职位',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 60,
            render: (text,record,index) => {
                const {edit} = record                 
                return edit?<Input style={{width:'100%'}} placeholder="请输入" value={text} onChange={e => this.handleChange(e.target.value,index,'positionName')}/>:text
            }
        }, {
            title: '联系人电话',
            dataIndex: 'userMobile',
            key: 'userMobile',
            width: 100,
            render: (text,record,index) => {
                const {edit} = record                 
                return edit?<Input style={{width:'100%'}} placeholder="请输入" value={text} onChange={e => this.handleChange(e.target.value,index,'userMobile')}/>:text
            }
        }, {
            title: '联系人邮箱',
            dataIndex: 'userMail',
            key: 'userMail',
            width: 100,
            render: (text,record,index) => {
                const {edit} = record                 
                return edit?<Input style={{width:'100%'}} placeholder="请输入" value={text} onChange={e => this.handleChange(e.target.value,index,'userMail')}/>:text
            }
        }, {
            title: '省份',
            dataIndex: 'provinceName',
            key: 'provinceName',
            width: 80,
            render: (text,record,index) => {
                const {edit} = record;
                const { provinceList } = this.state;     
                const provinceOptions = provinceList.map( i => <Option value={i.label}>{i.label}</Option>) 
                return edit?
                    <Select 
                        allowClear={true}
                        onFocus={this.getRegionTree}
                        placeholder="请选择"
                        style={{width:'100%'}} 
                        value={text?text:undefined} 
                        onChange={value => this.handleChange(value,index,'provinceName')}
                    >
                        {provinceOptions}
                    </Select>
                    :text
            }
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
            render: (text,record,index) => {
                const {edit, provinceName} = record;  
                const {cityList} = this.state; 
                const cityOptions = cityList.map( i => <Option value={i.label}>{i.label}</Option>)               
                return edit?
                    <Select 
                        allowClear={true}
                        onFocus={()=>this.queryCityList(provinceName)}
                        placeholder="请选择"
                        style={{width:'100%'}} 
                        value={text?text:undefined} 
                        onChange={value => this.handleChange(value,index,'cityName')}
                    >
                        {cityOptions}
                    </Select>
                    :text
            }
        }, {
            title: '区',
            dataIndex: 'countyName',
            key: 'countyName',
            width: 80,
            render: (text,record,index) => {
                const {edit} = record                 
                return edit?<Input style={{width:'100%'}} placeholder="请输入" value={text} onChange={e => this.handleChange(e.target.value,index,'countyName')}/>:text
            }
        }, {
            title: '详细地址',
            dataIndex: 'address',
            key: 'address',
            width: 60,
            render: (text,record,index) => {
                const {edit} = record                 
                return edit?<Input style={{width:'100%'}} placeholder="请输入" value={text} onChange={e => this.handleChange(e.target.value,index,'address')}/>:text
            }
        }, {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: 60,
            render: (text,record,index) => {
                const {edit, status} = record;
                if(text){text = (status == 'WORKING' )?'在职':'离职';}                 
                return edit?
                    <Select 
                        allowClear={true}
                        placeholder="请选择"
                        style={{width:'100%'}} 
                        value={text} 
                        onChange={value => this.handleChange(value,index,'status')}
                    >
                        <Option value={'WORKING'}>{'在职'}</Option>
                        <Option value={'LEFT'}>{'离职'}</Option>
                    </Select>
                    :text
            }
        }, {
            title: '备注',
            dataIndex: 'comment',
            key: 'comment',
            width: 60,
            render: (text,record,index) => {
                const {edit} = record                 
                return edit?<Input style={{width:'100%'}} placeholder="请输入" value={text} onChange={e => this.handleChange(e.target.value,index,'comment')}/>:text
            }
        }, {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 80,
            render: (text, record, index) => {
                const { edit, provinceName } = record;
                const { csaList } = this.state.record;
                const { curRole, userId } = sessionStorage;
                const isCSAL = curRole === 'CSAL';
                const isCSA = curRole === 'CSA';
                const isUser = csaList.some(i => i.userId == userId);
                return (
                    (isCSAL || (isCSA && isUser))?
                    <span>
                        {edit?
                            <a onClick={() => this.save(record,index)}>{'保存'}</a> 
                            :
                            <a onClick={() => this.edit(!edit,index,provinceName)}>{'修改'}</a>
                        }
                        <span className="ant-divider" />
                        <Popconfirm title={'确定要删除吗?'} onConfirm={() => this.onDelete(record,index)} okText="确定" cancelText="取消">
                        <a>删除</a>
                        </Popconfirm>
                    </span>
                    :
                    {text}
                )
            }
        }];
        return columns;
    }

    render() {
        const { record, data, pagination, canAdd, searchParams } = this.state;
        const { customerCompanyName, customerCompanyCode } = record;
        const { csaList } = this.state.record;
        const { curRole, userId } = sessionStorage;
        const isCSAL = curRole === 'CSAL';
        const isCSA = curRole === 'CSA';
        const isUser = (csaList || []).some(i => i.userId == userId);
        return (
    
            <Modal
                title="联系人信息"
                visible={this.state.visible}
                onCancel={this.hide}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
                width={'1140px'}
            >
                    <div className="filter-bar">
                        <div className="filter-bar-investigation" style={{width:'100%'}}>
                            <h3 style={{float:'left'}}>客户公司：{`${customerCompanyName}(${customerCompanyCode})`}</h3>
                            <h3 style={{position: 'absolute', top: 45}}>联系人信息</h3>
                        </div>
                        <div className="filter-bar-investigation" style={{width:'100%'}}>
                            <div className="form-item" style={{float:'right'}}>
                                <label htmlFor="" className="ui-label">联系人电话</label>
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 80, marginRight: 10 }}
                                    value={searchParams.userMobile}
                                    onChange={e => this.handleSearchChange(e.target.value, 'userMobile')}
                                />
                                <label htmlFor="" className="ui-label">联系人邮箱</label>
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 80, marginRight: 10  }}
                                    value={searchParams.userMail}
                                    onChange={e => this.handleSearchChange(e.target.value, 'userMail')}
                                />
                                
                                {
                                (isCSAL || (isCSA && isUser))  &&
                                <Button type='primary' style={{marginLeft: '5px'}} onClick={this.addPerson} disabled={canAdd}>添加</Button>
                                }
                                <Button type="primary" onClick={this.search}>搜索</Button>
                            </div>
                        </div>
                    </div>
                    <TableC
                        data={data}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
            </Modal>
        )
    }
    }



// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/Components/ConactInformation.js